.ag{justify-content:space-between;}